import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Checkbox,
    IconButton,
    Typography
} from '@material-ui/core';
import {
    KeyboardArrowDown,
    KeyboardArrowRight
} from '@material-ui/icons';
import { TreeTable, TreeState } from 'cp-react-tree-table';
import { useTheme } from '@material-ui/core/styles';
// import usePermission from 'src/hooks/usePermission';
import './tree.css';

const TreeTableComponent = (props) => {
    // const PermissionContext = usePermission();
    const { treeTableList, slctedList, allChecked, updateSlcted } = props;
    const [tabelData, setTableData] = useState<any>([]);
    const theme = useTheme();

    const handleOnChange = (newValue) => {
        setTableData(newValue);
    };
    const findCheckSts = (row, permission) => {
        const currentPermissionKey = row?.data?.permissions.find((item) => item.permission === permission)?.configUserRolePermissionKey;
        if (currentPermissionKey) {
            if (slctedList.find((item) => item === currentPermissionKey)) {
                return true;
            }
        }
        return false;
    };
    const checkIsExist = (row, action) => {
        const currentRow = row?.data?.permissions.find((item) => item.permission === action);
        if (currentRow?.configUserRolePermissionKey) {
            return false;
        }
        return true;
    };
    const checkAllSts = () => {
        if (slctedList.length === allChecked) return true;
        return false;
    };
    const selectAllRow = (row, isAllSelected) => {
        if (isAllSelected) {
            const list = [];
            const permissionList = [];
            row?.data?.permissions.map((item) => (list.push(item.configUserRolePermissionKey) && permissionList.push(item.permission)));
            const removeList = slctedList.filter((item) => {
                return list.indexOf(item) < 0;
            });
            updateSlcted(removeList);
        } else {
            const list = [];
            const permissionList = [];
            row?.data?.permissions.map((item) => (list.push(item.configUserRolePermissionKey) && permissionList.push(item.permission)));
            const arrayConcated = list.concat(slctedList);
            const final = [...new Set(arrayConcated)];
            updateSlcted(final);
        }
    };

    const checkActionSts = (action) => {
        const list = [];
        const arrayFunc = (array) => {
            /* eslint-disable-next-line */
            array.map((permission) => {
                /* eslint-disable-next-line */
                permission.data?.permissions.map((item) => {
                    if (item.permission === action) list.push(item.configUserRolePermissionKey);
                });
                if (permission.children?.length > 0) {
                    arrayFunc(permission.children);
                }
            });
        };
        arrayFunc(treeTableList);
        const alladded = list.every((element) => {
            return slctedList.includes(element);
        });
        return alladded;
    };
    const checkRowSts = (row) => {
        const list = [];
        row?.data?.permissions.map((item) => (list.push(item.configUserRolePermissionKey)));
        const alladded = list.every((element) => {
            return slctedList.includes(element);
        });
        return alladded;
    };

    const renderIndexCell = (row) => {
        return (
            <span className="index_cell">
                <Checkbox style={{ marginLeft: 0 }} checked={checkAllSts() || checkRowSts(row)} onClick={() => {
                    selectAllRow(row, checkRowSts(row));
                }} />
            </span>
        );
    };

    const renderFeaturesCell = (row) => {
        return (
            <div style={{ marginLeft: -15, paddingLeft: `${(row.metadata.depth * 25)}px` }}
                className={row.metadata.hasChildren ? 'with-children' : 'without-children'}>
                {(row.metadata.hasChildren) && (row.$state.isExpanded ? (
                    <IconButton onClick={row.toggleChildren}>
                        <KeyboardArrowDown fontSize="small" />
                    </IconButton>
                ) : (
                    <IconButton onClick={row.toggleChildren}>
                        <KeyboardArrowRight fontSize="small" />
                    </IconButton>
                ))}
                <span style={{ marginLeft: (!row.metadata.hasChildren && row.metadata.depth === 0) ? 29 : 0 }}>{row.data.featureName}</span>
            </div>
        );
    };

    const addUpdatePsion = (row, action) => {
        const currentRow = row?.data?.permissions.find((item) => item.permission === action);
        const isExist = slctedList.find((item) => item === currentRow?.configUserRolePermissionKey);
        if (isExist) {
            const filterdList = slctedList.filter((item) => {
                return item !== isExist;
            });
            updateSlcted(filterdList);
        } else {
            /* eslint-disable-next-line */
            if (currentRow?.configUserRolePermissionKey) updateSlcted(slctedList.concat([currentRow?.configUserRolePermissionKey]));
        }
    };
    const renderActionCell = (row, action) => {
        return (
            <span className="action-cell">
            {row.metadata.depth !== 0 && (
                <Checkbox
                disabled={checkIsExist(row, action)}
                checked={findCheckSts(row, action) && findCheckSts(row, 'View')}
                onClick={() => {
                    addUpdatePsion(row, action);
                }}
                />
            )}
            </span>
        );
    };

    const SelectAll = (value) => {
        const list = [];
        if (value) {
            const arrayFunc = (treeTableLists) => {
                /* eslint-disable-next-line */
                treeTableLists.map((permission) => {
                    /* eslint-disable-next-line */
                    permission.data?.permissions.map((item) => {
                        if (item.configUserRolePermissionKey) list.push(item.configUserRolePermissionKey);
                    });
                    if (permission.children?.length > 0) {
                        arrayFunc(permission.children);
                    }
                });
            };
            arrayFunc(treeTableList);
            updateSlcted(list);
        } else {
            updateSlcted(list);
        }
    };

    const selectAllColumns = (value, add = true) => {
        const list = [];
        const arrayFunc = (array) => {
            /* eslint-disable-next-line */
            array.map((permission) => {
                /* eslint-disable-next-line */
                permission.data?.permissions.map((item) => {
                    if (item.permission === value) {
                        list.push(item.configUserRolePermissionKey);
                    }
                });
                if (permission.children?.length > 0) {
                    arrayFunc(permission.children);
                }
            });
        };
        arrayFunc(treeTableList);
        if (add) {
            const arrayConcated = list.concat(slctedList);
            const final = [...new Set(arrayConcated)];
            updateSlcted(final);
        } else {
            const removeList = slctedList.filter((item) => {
                return list.indexOf(item) < 0;
            });
            updateSlcted(removeList);
        }
    };

    useEffect(() => {
        if (treeTableList && treeTableList.length > 0 && treeTableList[0].children) {
            setTableData(TreeState.expandAll(TreeState.create(treeTableList)));
        }
    }, [treeTableList]);

    return (
        <div className={`tree-table-wrapper-${theme.palette.mode}`}>
            <TreeTable
                className="demo-tree-table"
                height={tabelData?.height}
                headerHeight={46}
                value={tabelData}
                onChange={handleOnChange}>
                <TreeTable.Column basis="10px"
                    grow={0.35}
                    renderCell={renderIndexCell}
                    renderHeaderCell={() => (
                        <Checkbox checked={checkAllSts()} onClick={() => {
                            SelectAll(!checkAllSts());
                        }} />
                    )} />
                <TreeTable.Column basis="180px"
                    renderCell={renderFeaturesCell}
                    renderHeaderCell={() => <span className="t-left" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                    Select All
                  </span>} />
                {
                    treeTableList[0]?.children[1]?.data?.permissions.map((element) => (
                        <TreeTable.Column
                            key={element.permission}
                            renderCell={(e) => renderActionCell(e, element.permission)}
                            renderHeaderCell={() => (
                                <span className="t-right">
                                    <Checkbox checked={checkAllSts() || checkActionSts(element.permission)} onChange={() => selectAllColumns(element.permission, !checkActionSts(element.permission))} />
                                    <Typography style={{ marginTop: 5 }}>
                                        {element.permission}
                                    </Typography>
                                </span>
                            )}
                        />
                    ))
                }
            </TreeTable>
        </div>
    );
};

TreeTableComponent.propTypes = {
    treeTableList: PropTypes.array.isRequired,
    slctedList: PropTypes.array.isRequired,
    allChecked: PropTypes.number.isRequired,
    updateSlcted: PropTypes.func.isRequired,
};

export default TreeTableComponent;
